import { updateField } from "vuex-map-fields";
import useState from "./state";
import { resetState } from "../../../../util/reset_store_state/reset_store_state";

const LOADING_EDIT_PAGE = (state, bool) => {
  state.loadingEditPage = bool;
};

const SET_INITIAL_EDIT_PAGE_DATA = (state, page) => {
  state.formToEdit = page.form;
  state.renderableInputs = page.renderableInputs;
  state.overview = page.overview;
};
export default {
  SET_INITIAL_EDIT_PAGE_DATA,
  LOADING_EDIT_PAGE,
  updateField,
  resetState: resetState(useState),
};
